<div class="container mt-3 mx-auto">
    <div class="alert alert-info" *ngIf="!protocolos || !protocolos.length">
        Não foram encontrados arquivos de protocolo com os filtros informados.
    </div>

    <div *ngIf="protocolos?.length">
        <bn-paginacao 
            [total]="atributosPaginacao.count" 
            [tamanhoPagina]="atributosPaginacao.pageSize"
            [numPagina]="atributosPaginacao.page" 
            [opcoesTamanhoPagina]="opcoesPaginacao"
            (aoMudar)="mudancaPagina($event)">
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th id="col-id-protocolo" scope="col" *ngIf="!cnpjAgente">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'siglaAgente'"
                                    [nomeAtributoExibicao]="'Agente financeiro'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th id="col-id-protocolo" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'idProtocoloNegocio'"
                                    [nomeAtributoExibicao]="'ID protocolo'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th id="col-modo-envio" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'apenasValidacao'"
                                    [nomeAtributoExibicao]="'Modo de envio'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th id="col-data-envio" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'dataEnvio'"
                                    [nomeAtributoExibicao]="'Dt. envio'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th id="col-usu-envio" scope="col" *ngIf="cnpjAgente">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'usuarioEnvio'"
                                    [nomeAtributoExibicao]="'Usu. envio'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th id="col-status" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'statusProtocolo'"
                                    [nomeAtributoExibicao]="'Status'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-tipo-protocolo" scope="col" *ngIf="exibirComboTipoArquivo">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'tipoProtocolo'"
                                    [nomeAtributoExibicao]="'Tipo Protocolo'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th scope="col" class="text-end">
                                Arquivo envio
                            </th>
                            <th scope="col" class="text-end">
                                Arquivo resposta
                            </th>
                            <th></th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let protocolo of protocolos">
                            <td class="font-monospace" *ngIf="!cnpjAgente">{{ protocolo.siglaAgente }}</td>
                            <td class="font-monospace">{{ protocolo.idProtocoloNegocio }}</td>
                            <td class="font-monospace">{{ protocolo.apenasValidacao ? 'Apenas validação' : 'Efetivo' }}
                            </td>
                            <td>{{ protocolo.dataEnvio | date: 'dd/MM/yyyy HH:mm'}}</td>
                            <td *ngIf="cnpjAgente">{{ protocolo.usuarioEnvio}}</td>
                            <td>{{ obterLabelStatusProtocolo(protocolo.statusProtocolo) }}</td>
                            <td *ngIf="exibirComboTipoArquivo">{{ obterTipoProtocolo(protocolo.tipoProtocolo) }}</td>
                            <td class="text-end">
                                <a href="javascript:void(0)"
                                    (click)="downloadArquivoEnvio(protocolo.idProtocoloNegocio)">
                                    <span class="font-monospace fw-bold"> {{ protocolo.tamanhoConteudoEnvio |
                                        fileSize }} </span>
                                    <i class="fa fa-download">
                                    </i>
                                </a>
                            </td>
                            <td class="text-end">
                                <span *ngIf="protocolo.tamanhoConteudoResposta; else conteudoRespostaNaoDisponivel">
                                    <a href="javascript:void(0)"
                                        (click)="downloadArquivoResposta(protocolo.idProtocoloNegocio)">
                                        <span class="font-monospace fw-bold"> {{
                                            protocolo.tamanhoConteudoResposta | fileSize }} </span>
                                        <i class="fa fa-download"></i>
                                    </a>
                                    <span class="ms-1" *ngIf="protocolo.conteudoRespostaContemMensagemAlerta">
                                        <span> </span><i class="fas fa-exclamation-triangle color-orange"
                                            ngbTooltip="Existem avisos no arquivo de resposta."></i>
                                    </span>
                                </span>
                                <ng-template #conteudoRespostaNaoDisponivel>
                                    <span class="font-monospace">Não disponível</span>
                                </ng-template>
                            </td>
                            <td> 
                                <a *ngIf="perfilAgenteTransacional && podeCancelar(protocolo)" href="javascript:void(0)" (click)="abrirCancelarProtocolo($event, protocolo)">
                                    <i class="fa fa-ban text-danger cursor-pointer  ms-5" placement="left-top" ngbTooltip="Cancela o protocolo."></i>
                                  </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </bn-paginacao>
    </div>
</div>

<ng-template #msgTemplateCancelarProtocolo>
    Confirmar o cancelamento do protocolo selecionado.
    <br />
    <br />
    Esta ação não poderá ser desfeita.
    <br />
  </ng-template>
  <ng-template #botoesPersonalizadosCancelarProtocolo>
    <button class="btn btn-md btn-primary" (click)="close()">
      Cancelar
    </button>
    <button class="btn btn-md btn-danger" (click)="cancelarProtocolo()">
      Ok
    </button>
  </ng-template>